var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal-delivery",
      attrs: { visible: _vm.modalVisible },
      on: { "on-close": _vm.onCloseModal }
    },
    [
      _c("div", { staticClass: "delivery-selector" }, [
        _c("div", { staticClass: "delivery-selector__title" }, [
          _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } }),
          _c(
            "span",
            {
              staticClass: "delivery-selector__city",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.changeCity($event)
                }
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.USER_CITY.name) + "\n      ")]
          )
        ]),
        _c(
          "div",
          { staticClass: "delivery-selector__body" },
          [
            _vm.viewType === _vm.viewTypes.courier.value
              ? _c(
                  "delivery-courier-tab",
                  {
                    attrs: {
                      products: _vm.products,
                      "products-count": _vm.productsCount,
                      "shipping-channels": _vm.shippingChannels,
                      "current-city": _vm.USER_CITY
                    },
                    on: {
                      "change-view": function($event) {
                        _vm.viewType = $event
                      },
                      close: _vm.closeModal
                    }
                  },
                  [
                    _c("ui-segmented", {
                      staticClass: "delivery-selector__view-type",
                      attrs: { labels: Object.values(_vm.viewTypes) },
                      model: {
                        value: _vm.viewType,
                        callback: function($$v) {
                          _vm.viewType = $$v
                        },
                        expression: "viewType"
                      }
                    }),
                    _c("checkout-delivery-widget", {
                      staticClass: "delivery-selector__delivery-widget",
                      attrs: { place: _vm.WIDGET_PLACES.courier }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.viewType === _vm.viewTypes.pickup.value
              ? _c(
                  "delivery-pickup-tab",
                  {
                    attrs: {
                      products: _vm.products,
                      "point-id": _vm.pointId,
                      "current-city": _vm.USER_CITY
                    },
                    on: { close: _vm.closeModal }
                  },
                  [
                    _c("ui-segmented", {
                      staticClass: "delivery-selector__view-type",
                      attrs: { labels: Object.values(_vm.viewTypes) },
                      model: {
                        value: _vm.viewType,
                        callback: function($$v) {
                          _vm.viewType = $$v
                        },
                        expression: "viewType"
                      }
                    }),
                    _c("checkout-delivery-widget", {
                      staticClass: "delivery-selector__delivery-widget",
                      attrs: { place: _vm.WIDGET_PLACES.pickup }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }